import RoomsTable from './RoomsTable';

export default RoomsTable;
